// styles/colors.ts
import type { ButtonTone } from './context/useButton';

/** 배경색 매핑 (purge-safe) */
export const TONE_BG_CLASS: Record<ButtonTone, string> = {
  tag1: 'bg-system-tag1',
  red: 'bg-system-red1',
  red2: 'bg-system-red2',
  blue: 'bg-system-blue',
  yellow: 'bg-system-yellow',
  mint: 'bg-system-mint',
  mintLight: 'bg-system-mint-light',
  redLight: 'bg-system-red-light',
  yellowLight: 'bg-system-yellow-light',
  blueLight: 'bg-system-blue-light',
  green: 'bg-system-green',
  purple2: 'bg-system-purple2',
  brandPrimary: 'bg-brand-primary',
  brandSecondary: 'bg-brand-secondary',
  brandTertiary: 'bg-brand-tertiary',
};

/** 보더색 매핑 (purge-safe) */
export const TONE_BORDER_CLASS: Record<ButtonTone, string> = {
  tag1: 'border-system-tag1',
  red: 'border-system-red1',
  red2: 'border-system-red2',
  blue: 'border-system-blue',
  yellow: 'border-system-yellow',
  mint: 'border-system-mint',
  mintLight: 'border-system-mint-light',
  redLight: 'border-system-red-light',
  yellowLight: 'border-system-yellow-light',
  blueLight: 'border-system-blue-light',
  green: 'border-system-green',
  purple2: 'border-system-purple2',
  brandPrimary: 'border-brand-primary',
  brandSecondary: 'border-brand-secondary',
  brandTertiary: 'border-brand-tertiary',
};
